import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

const ActionCard = (props) => {
  const {
    buttonIcon,
    buttonLink,
    buttonText,
    children,
    headIcon,
    superTitle,
    title,
    background,
  } = props;

  return (
    <div className={`actionCard ${background ? 'bgEnabled' : ''}`}>
      {/* If titles exist, render titles */}
      {title &&
        <h4>
          {headIcon && <FontAwesomeIcon icon={['fas', headIcon]} />}
          {title}
        </h4>
      }
      {superTitle && <p>{superTitle}</p>}

      {/* Render content between component brackets in parent */}
      {children}

      {/* If button exists, render button */}
      {buttonText &&

        buttonLink &&
        <Link to={buttonLink}>
          <button className="button primary">
            {buttonIcon && <FontAwesomeIcon icon={['fas', buttonIcon]} />}
            {buttonText}
          </button>
        </Link>
      }
      {buttonText && !buttonLink &&
        <button className="button primary">
          {buttonIcon && <FontAwesomeIcon icon={['fas', buttonIcon]} />}
          {buttonText}
        </button>
      }
    </div>
  );
};

ActionCard.propTypes = {
  headIcon: PropTypes.string,
  superTitle: PropTypes.string,
  title: PropTypes.string,
  buttonIcon: PropTypes.string,
  children: PropTypes.node,
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  background: PropTypes.bool,
};

ActionCard.defaultProps = {
  headIcon: '',
  superTitle: '',
  title: '',
  buttonIcon: '',
  children: null,
  buttonLink: '',
  buttonText: '',
  background: false,
};

export default ActionCard;
